/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faqtitle1Inputs */

const zh_pricing_faqtitle1 = /** @type {(inputs: Pricing_Faqtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

const en_pricing_faqtitle1 = /** @type {(inputs: Pricing_Faqtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const es_pricing_faqtitle1 = /** @type {(inputs: Pricing_Faqtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas Frecuentes`)
};

/**
* | output |
* | --- |
* | "Frequently Asked Questions" |
*
* @param {Pricing_Faqtitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faqtitle1 = /** @type {((inputs?: Pricing_Faqtitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faqtitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faqtitle1(inputs)
	if (locale === "en") return en_pricing_faqtitle1(inputs)
	return es_pricing_faqtitle1(inputs)
});
export { pricing_faqtitle1 as "pricing_faqTitle" }